import React from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import styles from './MessageErreur.module.scss';

/**
 * Message d'erreur d'un champ de formulaire.
 *
 * Se pose en frère d'un input existant, jamais en remplacement : le champ garde
 * son balisage et ses classes. Sans erreur, le composant ne rend rien, donc
 * l'ajouter à un formulaire ne change rien à l'affichage tant qu'aucune erreur
 * n'est levée.
 *
 * @param {object} props
 * @param {string|null} props.cle - clé de traduction issue du schéma Zod
 */
const MessageErreur = ({ cle }) => {
  if (!cle) {
    return null;
  }

  return (
    <div className={styles.message} role="alert">
      {checkMot(cle)}
    </div>
  );
};

export default MessageErreur;

/** Classe à poser sur le champ lui-même pour l'entourer de rouge. */
export const classeChampEnErreur = styles.champEnErreur;
